document.addEventListener("DOMContentLoaded", function() {
  const addToCartBtn = document.querySelector('button.add_to_cart');
  const monogramCheckbox = document.getElementById('add-monogram-fee');
  const engravingCheckbox = document.getElementById('add-engraving-fee');

  const MONOGRAM_FEE_VARIANT_ID = 42751028232305;
  const ENGRAVING_FEE_VARIANT_ID = 32243482198129;

  if (!addToCartBtn) return;

  addToCartBtn.addEventListener('click', async function() {
    try {
      const itemsToAdd = [];
      if (monogramCheckbox && monogramCheckbox.checked) {
        itemsToAdd.push({
          id: MONOGRAM_FEE_VARIANT_ID,
          quantity: 1,
          properties: { _fee_type: "Monogram Fee" }
        });
      }
      if (engravingCheckbox && engravingCheckbox.checked) {
        itemsToAdd.push({
          id: ENGRAVING_FEE_VARIANT_ID,
          quantity: 1,
          properties: { _fee_type: "Engraving Fee" }
        });
      }
      if (itemsToAdd.length === 0) return;

      for (const item of itemsToAdd) {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [item] })
        });
        const data = await response.json();
        console.log(`✅ ${item.properties._fee_type} added:`, data);
      }
    } catch (error) {
      console.error("⚠️ Error adding fee(s):", error);
    }
  });
});
